import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.filter";
import "core-js/modules/es.array.includes";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.map";
import "core-js/modules/es.object.get-own-property-descriptor";
import "core-js/modules/es.object.get-prototype-of";
import "core-js/modules/es.object.keys";
import "core-js/modules/es.object.set-prototype-of";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/web.dom-collections.for-each";
import "core-js/modules/web.dom-collections.iterator";

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; var ownKeys = Object.keys(source); if (typeof Object.getOwnPropertySymbols === 'function') { ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function (sym) { return Object.getOwnPropertyDescriptor(source, sym).enumerable; })); } ownKeys.forEach(function (key) { _defineProperty(target, key, source[key]); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

import PropTypes from 'prop-types';
import React, { Component } from 'react';
import classNames from 'classnames';
import { FormattedMessage } from 'react-intl';
import isMobile from 'helpers/isMobile';
import { renderMarkdown, resetMarkdownCache } from 'helpers/markdown';
import { trackOptimizelyEvent } from 'helpers/optimizely';
import { isEmpty, isPresent } from 'helpers/verify';
import { CalloutCard } from 'components/CardSelection';
import { LocationSelector } from 'components/CmsPage/modules/LocationSelector/LocationSelector';
import { PLAN } from 'constants/plan-types';
import { readSessionStorage } from 'redux/saga/helpers/local-storage'; // The Nike-specific methods are a temporary hack to enable
// Nike Plus Unlock card decorations in full-fare pricing pages, before
// we rework pricing pages to handle contextual promotions.

var NIKEFIVE = 'nikefive';
var NIKETEN = 'niketen';
export var PlanSelection =
/*#__PURE__*/
function (_Component) {
  _inherits(PlanSelection, _Component);

  function PlanSelection(props) {
    var _this;

    _classCallCheck(this, PlanSelection);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PlanSelection).call(this, props));
    _this.handleSelectPlanClick = _this.handleSelectPlanClick.bind(_assertThisInitialized(_this));
    _this.state = {
      selectedItemId: null,
      selectedItemType: null
    };
    return _this;
  }

  _createClass(PlanSelection, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.resetCardSelectionState(this.props.cards);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this$props = this.props,
          cards = _this$props.cards,
          loadCardData = _this$props.loadCardData,
          plansModuleConfig = _this$props.plansModuleConfig;

      if (plansModuleConfig !== prevProps.plansModuleConfig) {
        loadCardData(plansModuleConfig);
      }

      if (isMobile() && !this.areCardsEqual(cards, prevProps.cards)) {
        this.resetCardSelectionState(cards);
      }
    }
  }, {
    key: "onDwell",
    value: function onDwell() {
      trackOptimizelyEvent('view_plans');
    }
  }, {
    key: "getCpOptimize",
    value: function getCpOptimize() {
      try {
        return this.props.isClient ? readSessionStorage('cpOptimize') : null;
      } catch (e) {
        return null;
      }
    }
  }, {
    key: "areCardsEqual",
    value: function areCardsEqual(cards, prevCards) {
      return cards.length === prevCards.length && cards.every(function (card, idx) {
        return card.itemId === prevCards[idx].itemId;
      });
    }
  }, {
    key: "decorateNikePlusCards",
    value: function decorateNikePlusCards(cards) {
      var _NIKEFIVE$NIKETEN$thi;

      var decorateIndex = (_NIKEFIVE$NIKETEN$thi = {}, _defineProperty(_NIKEFIVE$NIKETEN$thi, NIKEFIVE, 1), _defineProperty(_NIKEFIVE$NIKETEN$thi, NIKETEN, 2), _NIKEFIVE$NIKETEN$thi)[this.getCpOptimize()];
      var targetCard = cards[decorateIndex];

      if (!targetCard || targetCard.isNikePlusDecorated) {
        return cards;
      }

      var planPrice = targetCard.callout.replace(/\*/g, '');
      cards[decorateIndex] = _objectSpread({}, targetCard, {
        callout: '$*0*',
        calloutNote: "~~".concat(planPrice, "~~ first month"),
        isNikePlusDecorated: true,
        tag: 'NikePlus Unlock'
      }); // When we SSR, we don't have sessionStorage available.
      // So the first render renders without the NikePlus decoration,
      // and the client-side render would otherwise be cached.
      // This only executes once, since we don't re-decorate cards.

      resetMarkdownCache();
      return cards;
    }
  }, {
    key: "trackNikePlus",
    value: function trackNikePlus() {
      var _NIKEFIVE$NIKETEN$thi2;

      var classCount = (_NIKEFIVE$NIKETEN$thi2 = {}, _defineProperty(_NIKEFIVE$NIKETEN$thi2, NIKEFIVE, 5), _defineProperty(_NIKEFIVE$NIKETEN$thi2, NIKETEN, 10), _NIKEFIVE$NIKETEN$thi2)[this.getCpOptimize()];
      trackOptimizelyEvent("NikePlus Unlock ".concat(classCount, "-Class"));
    }
  }, {
    key: "isNikePlusUnlock",
    value: function isNikePlusUnlock() {
      var cards = this.props.cards || [];
      return cards.length === 3 && cards.every(function (card) {
        return card.type === PLAN;
      }) && [NIKEFIVE, NIKETEN].includes(this.getCpOptimize());
    }
  }, {
    key: "resetCardSelectionState",
    value: function resetCardSelectionState(cards) {
      this.setState({
        selectedItemId: !isEmpty(cards) ? cards[0].itemId : 0,
        selectedItemType: !isEmpty(cards) ? cards[0].type : 0
      });
    }
  }, {
    key: "handleSelectPlanClick",
    value: function handleSelectPlanClick() {
      var _this$state = this.state,
          selectedItemId = _this$state.selectedItemId,
          selectedItemType = _this$state.selectedItemType;
      this.props.selectPlan(selectedItemType, selectedItemId);
    }
  }, {
    key: "handleCardClick",
    value: function handleCardClick(itemType, itemId, isNikePlus) {
      if (isMobile()) {
        this.setState({
          selectedItemId: itemId,
          selectedItemType: itemType
        });
      } else {
        this.props.selectPlan(itemType, itemId);
      }

      if (isNikePlus) {
        this.trackNikePlus();
      }
    }
  }, {
    key: "renderCards",
    value: function renderCards() {
      var _this2 = this;

      var cards = this.props.cards || [];
      return (this.isNikePlusUnlock() ? this.decorateNikePlusCards(cards) : cards).map(function (card) {
        return React.createElement(CalloutCard, {
          callout: renderMarkdown(card.callout, "card_callout_".concat(card.type, "_").concat(card.itemId)),
          calloutNote: renderMarkdown(card.calloutNote, "card_calloutNote_".concat(card.type, "_").concat(card.itemId)),
          ctaCopy: card.cta,
          details: renderMarkdown(card.details, "card_details_".concat(card.type, "_").concat(card.itemId)),
          key: card.itemId,
          onClick: function onClick() {
            return _this2.handleCardClick(card.type, card.itemId, card.isNikePlusDecorated);
          },
          selected: card.itemId === _this2.state.selectedItemId,
          tag: renderMarkdown(card.tag, "card_tag_".concat(card.type, "_").concat(card.itemId))
        });
      });
    }
  }, {
    key: "renderCta",
    value: function renderCta() {
      return React.createElement("button", {
        className: "bt bt--primary bt--lg plan-selection__cta",
        onClick: this.handleSelectPlanClick
      }, React.createElement(FormattedMessage, {
        id: "plan-selection.card.cta.select-plan",
        defaultMessage: "Select plan"
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          cards = _this$props2.cards,
          creditsPerClassAverage = _this$props2.creditsPerClassAverage,
          disclaimer = _this$props2.disclaimer,
          msaSelectorLeadin = _this$props2.msaSelectorLeadin,
          subtitle = _this$props2.subtitle,
          subtitleStyle = _this$props2.subtitleStyle,
          title = _this$props2.title;

      if (isEmpty(cards)) {
        return false;
      }

      return React.createElement("section", null, React.createElement("div", {
        className: "pricing color-background-light"
      }, React.createElement("div", {
        className: classNames('pricing__subtitle', "pricing__subtitle--".concat(subtitleStyle), {
          'hidden md-block': subtitleStyle === 'subtle'
        })
      }, subtitle), React.createElement("h2", {
        className: "pricing__header"
      }, title), React.createElement("div", {
        className: "pricing__location-input pb++"
      }, React.createElement("div", {
        className: "pricing__location-input__location"
      }, React.createElement(LocationSelector, {
        label: msaSelectorLeadin
      })))), React.createElement("div", {
        className: "pricing__plans plan-selection"
      }, this.renderCards(), this.renderCta()), disclaimer && React.createElement("p", {
        className: "pricing__disclaimer text--center"
      }, disclaimer), !disclaimer && isPresent(creditsPerClassAverage) && React.createElement("p", {
        className: "pricing__disclaimer text--center"
      }, React.createElement(FormattedMessage, {
        id: "plan-selection.disclaimer.average-credits-per-class",
        defaultMessage: "The average class in your area costs {creditsPerClassAverage, plural, one {# credit} other {# credits}}.",
        values: {
          creditsPerClassAverage: creditsPerClassAverage
        }
      })));
    }
  }]);

  return PlanSelection;
}(Component);
PlanSelection.propTypes = {
  cards: PropTypes.arrayOf(PropTypes.shape({
    callout: PropTypes.string.isRequired,
    calloutNote: PropTypes.string.isRequired,
    cta: PropTypes.string.isRequired,
    details: PropTypes.string,
    itemId: PropTypes.number,
    tag: PropTypes.string,
    type: PropTypes.oneOf(['plan', 'offer'])
  })),
  creditsPerClassAverage: PropTypes.number,
  disclaimer: PropTypes.string,
  isClient: PropTypes.bool.isRequired,
  msaSelectorLeadin: PropTypes.string,
  plansModuleConfig: PropTypes.object,
  selectPlan: PropTypes.func.isRequired,
  loadCardData: PropTypes.func.isRequired,
  subtitle: PropTypes.string,
  subtitleStyle: PropTypes.oneOf(['subtle', 'loud']),
  title: PropTypes.string.isRequired
};